import React, { useState, useCallback } from 'react';
import { Modal } from 'antd';
import * as Style from "../styles/GroupSettings.style";

interface Props {
    isOpen: boolean;
    onClose: () => void;    
    tabNum: number;
    deviceNum: number;
    onAction: (tabNumber: number, deviceNumber: number) => void;
}

const DeviceConfirmButtonModal: React.FC<Props> = ({
    isOpen, onClose, tabNum, deviceNum, onAction
}) => {
  if (!isOpen) return null;

  return (

    <Modal 
        open={isOpen}
        onCancel={onClose}
        title={<center><h2>설정 적용 확인</h2></center>}
        footer={null}
        >

        <br></br><br></br><br></br><br></br>

        <Style.MotionModeSetListTitle>설정 적용 시 최대 1분 소요 됩니다. <br></br> 진행하겠습니까?</Style.MotionModeSetListTitle>

        <br></br><br></br><br></br><br></br>

        <Style.MotionModeSetModalButtonFrame>
            <Style.MotionModeSetModalCancleButton
                onClick={onClose}
            >
                닫기
            </Style.MotionModeSetModalCancleButton>

            <Style.MotionModeSetModalCancleButton
                onClick={()=>onAction(tabNum, deviceNum)}
            >
                {/* {tabNum} / {deviceNum}  */}
                확인 및 적용
            </Style.MotionModeSetModalCancleButton>
        </Style.MotionModeSetModalButtonFrame>

    </Modal>    
  );
};
export default DeviceConfirmButtonModal;